module.exports = __webpack_public_path__ + "static/media/Inter Milan.e45f5805.jpg";